/* OVERKICKS - Nota del pedido (order note)

   Web component <order-note> que controla el despliegue del panel y el feedback
   de "guardado". El autoguardado en cart.note lo hace ya el <cart-note> interno
   (definido en cart.js), que escucha el evento input y hace POST a cart/update.

   Se carga una sola vez con defer; connectedCallback se re-ejecuta cuando el
   cart drawer se vuelve a renderizar por AJAX, por eso el guardado de estado
   (abierto/cerrado) se persiste en sessionStorage por contexto. */
(function () {
  if (window.customElements.get('order-note')) return;

  const STORAGE_KEY = 'overkicks:order-note-open:';

  class OrderNote extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.context = this.dataset.context || 'drawer';
      this.toggle = this.querySelector('[data-order-note-toggle]');
      this.panel = this.querySelector('[data-order-note-panel]');
      this.input = this.querySelector('[data-order-note-input]');
      this.label = this.querySelector('[data-order-note-label]');
      this.saved = this.querySelector('[data-order-note-saved]');

      if (!this.toggle || !this.panel || !this.input) return;

      this.labelAdd = this.toggle.dataset.labelAdd || '';
      this.labelEdit = this.toggle.dataset.labelEdit || '';

      this.toggle.addEventListener('click', () => this.togglePanel());
      this.input.addEventListener('input', () => this.onInput());

      // Reabrir el panel si quedó abierto antes del re-render del drawer, o si
      // ya hay una nota escrita (para que sea visible de un vistazo).
      const wasOpen = sessionStorage.getItem(STORAGE_KEY + this.context) === '1';
      if (wasOpen) this.open();
    }

    togglePanel() {
      this.panel.hidden ? this.open() : this.close();
    }

    open() {
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      sessionStorage.setItem(STORAGE_KEY + this.context, '1');
      // Foco al textarea para que el usuario pueda escribir de inmediato.
      requestAnimationFrame(() => this.input.focus());
    }

    close() {
      this.panel.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      sessionStorage.setItem(STORAGE_KEY + this.context, '0');
    }

    onInput() {
      const hasNote = this.input.value.trim().length > 0;
      this.classList.toggle('order-note--filled', hasNote);

      // Cambiar la etiqueta del botón entre "Añadir" y "Editar" segun haya nota.
      if (this.label && this.labelAdd && this.labelEdit) {
        this.label.textContent = hasNote ? this.labelEdit : this.labelAdd;
      }

      // Mostrar el indicador "guardado" tras la pausa de autoguardado.
      if (this.saved) {
        clearTimeout(this._savedTimer);
        this.saved.hidden = true;
        this._savedTimer = setTimeout(() => {
          this.saved.hidden = !hasNote;
        }, 800);
      }
    }
  }

  window.customElements.define('order-note', OrderNote);
})();
